(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('PsychIntakeWorkflowController', PsychIntakeWorkflowController);

    PsychIntakeWorkflowController.$inject = ['$scope', '$state', '$translate', '$timeout', '$location', 'Auth', '$uibModal', '$window', 'JhiLanguageService', 'PsychIntakeService', 'psychIntake', 'dataWorkflow', '$localStorage', 'ipmConstants', '$rootScope', 'ClearLocalStorageService'];

    function PsychIntakeWorkflowController($scope, $state, $translate, $timeout, $location, Auth, $uibModal, $window, JhiLanguageService, PsychIntakeService, psychIntake, dataWorkflow, $localStorage, constants, $rootScope, ClearLocalStorageService) {
        var vm = this;

        vm.psychIntake = psychIntake;
        vm.dataWorkflow = dataWorkflow;

        vm.section = vm.dataWorkflow.section;
        vm.template = '';
        vm.datePickerOpenStatus = {
            dateOfInjury: false
        };
        vm.isInvitation = $window.localStorage.getItem(constants.INVITATION_WORKFLOW);
        vm.isLaunchAction = $window.localStorage.getItem(constants.PSYCH_INTAKE_FORM_ID) ? true : false;

        vm.init = function () {
            if (vm.dataWorkflow.action == 'COMPLETE') {
                vm.template = 'app/psych-intake/workflow/partial/thanks.html';
                vm.psychIntake['currentSection'] = {};
            } else {
                vm.template = 'app/psych-intake/workflow/partial/' + vm.dataWorkflow.section.template + '.html';
            }
        }

        vm.next = function () {
            vm.dataWorkflow.action = 'NEXT';
            vm.dataWorkflow.isInvitation = vm.isInvitation;
            vm.dataWorkflow.isLaunchAction = vm.isLaunchAction;
            PsychIntakeService.submitWorkflow(vm.dataWorkflow).then(function (res) {
                vm.dataWorkflow = res;
                vm.updateCurrentSection(res);
            });
        }

        vm.back = function () {
            vm.dataWorkflow.action = 'BACK';
            vm.dataWorkflow.isInvitation = vm.isInvitation;
            vm.dataWorkflow.isLaunchAction = vm.isLaunchAction;
            PsychIntakeService.submitWorkflow(vm.dataWorkflow).then(function (res) {
                vm.dataWorkflow = res;
                vm.updateCurrentSection(res);
            });
        }

        vm.updateCurrentSection = function (workflow) {
            vm.psychIntake.sectionIdsCompleted = workflow.sectionIdsCompleted;
            vm.psychIntake.totalSectionId = workflow.totalSectionId;
            if (workflow.action == 'COMPLETE') {
                vm.template = 'app/psych-intake/workflow/partial/thanks.html';
                vm.psychIntake['currentSection'] = {};
            } else if (workflow.section) {
                vm.template = 'app/psych-intake/workflow/partial/' + workflow.section.template + '.html';
                if (!vm.psychIntake.currentSection) {
                    vm.psychIntake['currentSection'] = workflow.section;
                } else {
                    vm.psychIntake.currentSection.id = workflow.section.id;
                    vm.psychIntake.currentSection.code = workflow.section.code;
                    vm.psychIntake.currentSection.template = workflow.section.template;
                    vm.psychIntake.currentSection.name = workflow.section.name;
                    vm.psychIntake.currentSection.nameLangKey = workflow.section.nameLangKey;
                    vm.psychIntake.currentSection.orderNumber = workflow.section.orderNumber;
                }
            }

            $window.scrollTo(0, 0);
        }

        vm.init();

        vm.nextPsychOrLogout = function () {
            PsychIntakeService.getNotCompleteForm().then(function (res) {
                if (res) {
                    ClearLocalStorageService.clearWorkflow();
                    goToPsychWorkflow();
                } else {
                    ClearLocalStorageService.clearAllAndWorkflow();
                    ClearLocalStorageService.clearLandingPage();
                    goToLandingPage();
                }
            });
        }

        function goToPsychWorkflow() {
            $state.go('psych-intake.workflow', null, { reload: true });
        }

        function goToLandingPage() {
            $state.go('landing-page');
        }

        vm.disabledIfNotSigned = function () {
            var disabled = false;
            if (vm.dataWorkflow.section.code === 'PATIENT_ACKNOWLEDGEMENT' && vm.dataWorkflow.answer.agreement && !vm.dataWorkflow.answer.agreement.patientSignature) {
                disabled = true;
            }
            return disabled;
        }
    }
})();
